import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Costanti app
export const CITY_NAME = import.meta.env.VITE_CITY_NAME || 'Cagliari'
export const DEFAULT_LAT = parseFloat(import.meta.env.VITE_DEFAULT_LAT) || 40.7259
export const DEFAULT_LNG = parseFloat(import.meta.env.VITE_DEFAULT_LNG) || 8.5568
export const DEFAULT_ZOOM = 13
